module.exports = __webpack_public_path__ + "static/media/digitalscouting.e7203406.png";